import { montarPreFinanceiroPayload } from './preFinanceiro';
// src utils/movimento/normalizeMovimentoPayload.js

import { normalizeMovimentoItemPayload } from './normalizeMovimentoItemPayload';

export function normalizeMovimentoPayload({ movimento, operacao, operacaoParametros }) {
    const preFinanceiro = montarPreFinanceiroPayload(movimento, operacao, operacaoParametros);
    const { preFinanceiro: ignorado, preFinanceiroConfiguracao: snapshot, ...cabecalho } = movimento;
    return {
        ...cabecalho,
        ...(preFinanceiro !== undefined ? { preFinanceiro } : {}),

        operacaoId: movimento.operacaoId ?? operacao?.id ?? operacaoParametros?.operacaoId,
        situacaoId: movimento.situacaoId ?? operacaoParametros?.situacaoId ?? operacaoParametros?.lancamentoSituacaoId,

        movimentoItems: (movimento.movimentoItems || [])
            .filter((item) => item.pedido === true)
            .map(normalizeMovimentoItemPayload),
    };
}
